export default Object.freeze({
  Delivery: 1,
  Open: 2,
  Click: 3,
});
